import React, { useEffect, useState } from 'react';
import './Admin_add_product.css';
import { useNavigate } from 'react-router-dom';

export default function Dashboard({ setLoggedIn }) {
  const [user, setUser] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name_id: '', name_en: '', name_cn: '', description_id: '', description_en: '', description_cn: '', category_id: '', category_en: '', category_cn: '', price: '', location: ''
  });
  const [files, setFiles] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // check session
    fetch('/backend/check_session.php', { credentials: 'include' })
      .then(r => r.json())
      .then(d => {
        if (!d.authenticated) {
          navigate('/formeb-login');
        } else {
          setUser(d.username || 'Admin');
        }
      });
  }, [navigate]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  }

  function handleFiles(e) {
    setFiles(e.target.files);
  }

  async function submit(e) {
    e.preventDefault();
    setMessage('');
    const fd = new FormData();
    fd.append('name_id', form.name_id);
    fd.append('name_en', form.name_en);
    fd.append('name_cn', form.name_cn);
    fd.append('description_id', form.description_id);
    fd.append('description_en', form.description_en);
    fd.append('description_cn', form.description_cn);
    fd.append('category_id', form.category_id);
    fd.append('category_en', form.category_en);
    fd.append('category_cn', form.category_cn);
    fd.append('price', form.price);
    fd.append('location', form.location);
    if (files) {
      for (let i = 0; i < files.length; i++) {
        fd.append('media[]', files[i]);
      }
    }
    try {
      const res = await fetch('/backend/add_product.php', {
        method: 'POST',
        credentials: 'include',
        body: fd
      });
      const data = await res.json();
      if (data.success) {
        setMessage('Product added');
        // clear form
        setForm({ name_id: '', name_en: '', name_cn: '', description_id: '', description_en: '', description_cn: '', category_id: '', category_en: '', category_cn: '', price: '', location: '' });
        setFiles(null);
      } else {
        setMessage(data.message || 'Failed to add product');
      }
    } catch (err) {
      setMessage('Server error');
    }
  }

  async function logout() {
    await fetch('/backend/logout.php', { credentials: 'include' });
    if (typeof setLoggedIn === 'function') setLoggedIn(false);
    navigate('/formeb-login');
  }

  // Handles navigation back to Admin Dashboard
  const handleGoBackToDashboard = () => {
    navigate('/formeb-dashboard'); // Assuming your route for AdminDashboard is /admin/dashboard
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <h2>Add Product</h2>
        <div>
          <button className="btn-secondary" onClick={handleGoBackToDashboard}>Go to Admin Dashboard</button> {/* New button */}
          <span>    </span>
          <button className="btn-logout" onClick={logout}>Logout</button>
        </div>
      </div>

      <form className="product-form" onSubmit={submit}>
        {message && <div className="message">{message}</div>}
        <input name="name_id" placeholder="Product name (Indonesia)" value={form.name_id} onChange={handleChange} required />
        <input name="name_en" placeholder="Product name (English)" value={form.name_en} onChange={handleChange} required />
        <input name="name_cn" placeholder="Product name (Chinese)" value={form.name_cn} onChange={handleChange} required />
        <textarea name="description_id" placeholder="Description (Indonesia)" value={form.description_id} onChange={handleChange} />
        <textarea name="description_en" placeholder="Description (English)" value={form.description_en} onChange={handleChange} />
        <textarea name="description_cn" placeholder="Description (Chinese)" value={form.description_cn} onChange={handleChange} />
        <input name="category_id" placeholder="Category (Indonesia)" value={form.category_id} onChange={handleChange} />
        <input name="category_en" placeholder="Category (English)" value={form.category_en} onChange={handleChange} />
        <input name="category_cn" placeholder="Category (Chinese)" value={form.category_cn} onChange={handleChange} />
        <input name="price" placeholder="Price" type="number" step="0.01" value={form.price} onChange={handleChange} />
        <input name="location" placeholder="Location" value={form.location} onChange={handleChange} />
        <input type="file" name="media" multiple onChange={handleFiles} accept="image/*,video/*" />
        <button type="submit">Add product</button>
      </form>

      {loading && (
        <div className="loading-modal">
          <div className="loading-content">
            <div className="spinner"></div>
            <p>Adding product to database...</p>
          </div>
        </div>
      )}

    </div>
  );
}
